// Helper function to apply transformers sequentially
export const transformValue = (value, transformers) => {
    return transformers.reduce((acc, transformer) => {
        return transformer(acc);
    }, value);
};
